import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as TargetUndo } from '../../assets/svg/undoTarget.svg';
import { ReactComponent as Settings } from '../../assets/svg/settings.svg';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Loading from '../Loading';
import CreateEditCourseModal from './CreateEditCourseModal';
import CourseSingleDay from './CourseSingleDay';
import ConfirmationModal from '../modals/ConfirmationModal';
import CourseDayEditing from './CourseDayEditing';
import { createUpdateCourse, deleteCourseById, deleteDayById, getCourseById, updateDaysListOrder } from '../../server/server';
import { notify } from '../../utils/util';
import MDEditor from '@uiw/react-md-editor';
import { fileSystemUrl } from '../../server/connections';
import ManageLanguageModal from './ManageLanguageModal';

function SingleCourseScreen() {
	const { id } = useParams();
	const navigate = useNavigate();
	const [course, setCourse] = useState<any>(null);
	const [loading, setLoading] = useState(true);
	const [hoveredButton, setHoveredButton] = useState(false);
	const [days, setDays] = useState<any>([]);
	const [currentDay, setCurrentDay] = useState(-1);
	const [indexDayForDelete, setIndexDayForDelete] = useState(-1);
	const [deleteDay, setDeleteDay] = useState(false);
	const [labelsModalVisible, setLabelsModalVisible] = useState(false);
	const [processing, setProcessing] = useState(false);
	const [deleteJournalModal, setDeleteJournalModal] = useState(false);
	const [createJournalModal, setCreateJournalModal] = useState(false);
	const [manageLangModalOpen, setManageLangModalOpen] = useState(false);

	useEffect(() => {
		if (!!id) loadCourse(id);
	}, [id]);

	const loadCourse = async (id: string) => {
		const resp = await getCourseById(id);
		if (resp.status == 200) {
			setDays(resp.data[0].days);
			setCourse(resp.data[0]);
			if (resp.data[0].days?.length > 0) setCurrentDay(0);
			setLoading(false);
		}
	};

	const addNewDay = () => {
		const elementId = days.find((element: any) => !element.hasOwnProperty('id'));
		if (elementId) {
			notify('You already have one empty day!');
			return;
		}
		setCurrentDay(days.length);
		setDays((prev: any) => [
			...prev,
			{
				title: '',
				description: '',
				question: '',
				numberOfAnswers: 1,
			},
		]);
	};

	const removeDay = async (index = indexDayForDelete) => {
		if (!!days[index]?.id) {
			const resp = await deleteDayById(days[index]?.id);
			if (resp.status === 200) {
				if (index <= currentDay && currentDay === days.length - 1) setCurrentDay((prev) => prev - 1);
				reloadCourse();
				notify('The day has been successfully deleted!');
			} else {
				notify('The course has not been deleted!');
			}
		} else {
			if (index <= currentDay && currentDay === days.length - 1) setCurrentDay((prev) => prev - 1);
			days.splice(index, 1);
		}
	};

	const deleteJournal = async () => {
		const resp = await deleteCourseById(id);
		if (resp.status === 200) {
			goBack();
			notify('The course has been successfully deleted!');
		} else {
			notify('The course has not been deleted!');
		}
	};

	const reloadCourse = () => {
		if (id) loadCourse(id);
	};

	const goBack = () => {
		navigate('/courses');
	};
	const changeVisibilty = async () => {
		let newCourse: any = {};
		newCourse.id = course.id;
		newCourse.headlineImageId = course.headlineImage?.id ?? null;
		newCourse.localeId = course.locale?.id ?? null;
		newCourse.mainCategoryId = course.mainCategory?.id ?? null;
		let newList: any[] = course.otherCategories.filter((item: any) => !!item.value);
		newList = newList.map((item: any) => {
			return { categoryId: item.category?.id, value: item.value };
		});
		newCourse.otherCategories = newList;
		newCourse.subtitle = course.subtitle;
		newCourse.title = course.title;
		newCourse.visible = !course.visible;
		console.log(newCourse);
		const resp = await createUpdateCourse(newCourse);
		if (resp.status === 201) {
			const courseFresh = resp.data;
			loadCourse(courseFresh.id);
			notify('Course visibility is changed');
		} else {
		}
	};

	const closeDeleteJournalModal = () => {
		setDeleteJournalModal(false);
	};

	const closeManageLanguageModal = () => {
		setManageLangModalOpen(false);
	};

	const closeCreateJournalModal = () => {
		setCreateJournalModal(false);
	};

	const closeDeleteDay = () => {
		setIndexDayForDelete(-1);
		setDeleteDay(false);
	};

	const handleDropQuestion = (droppedItem: any) => {
		// Ignore drop outside droppable container
		if (!droppedItem.destination) return;
		var updatedList = [...days];
		// Remove dragged item
		const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
		// Add dropped item
		updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
		// Update State
		setDays(updatedList);
		if (droppedItem.source.index === currentDay) setCurrentDay(droppedItem.destination.index);
		updatedList = updatedList.map((item: any, index: number) => {
			return { id: item?.id, order: index + 1 };
		});
		updateDaysList(updatedList);
	};

	const updateDaysList = async (updatedList: any) => {
		const resp = await updateDaysListOrder(updatedList);
		if (resp.status === 201) {
			notify('Order of the days has been successfully changed.');
		} else {
			notify("Order hasn't changed.");
		}
	};

	return (
		<div className='flex h-full flex-col items-center overflow-y-auto bg-[#ECEBF8] py-[40px]'>
			<div className=' w-full  max-w-[1200px] px-[10px] '>
				<div className='w-full  bg-white flex flex-col px-[40px] py-[30px] rounded-[10px]'>
					<div className='flex flex-row w-full items-start gap-5'>
						<div className='flex-1'>
							<div className='flex items-center justify-between'>
								<div className='flex '>
									<div
										className=' flex cursor-pointer mr-5 items-center justify-center bg-primaryViolet hover:bg-darkViolet  min-w-[56px] w-[56px] h-[56px] rounded-full'
										onClick={() => goBack()}
										onMouseEnter={() => setHoveredButton(true)}
										onMouseLeave={() => setHoveredButton(false)}
									>
										<TargetUndo fill={hoveredButton ? '#FDDF6D' : '#FFFFFF'} />
									</div>
									<h1 className='font-bold text-primaryViolet text-[40px]'>{course?.title}</h1>
								</div>
							</div>
							<div className='flex flex-row items-start  mt-5 gap-5'>
								<div className='flex flex-col gap-5'>
									{!!course?.headlineImage && (
										<div className='w-full max-w-[200px] rounded-xl bg-beeYellow'>
											<img style={{ objectFit: 'contain', width: '100%', maxHeight: 180, borderRadius: 10 }} src={fileSystemUrl + '/' + course.headlineImage?.url} alt='' />
										</div>
									)}
									{!!course?.onboardingImage && (
										<div className='w-full max-w-[200px] rounded-xl '>
											<img style={{ objectFit: 'contain', width: '100%', maxHeight: 180, borderRadius: 10 }} src={fileSystemUrl + '/' + course.onboardingImage?.url} alt='' />
										</div>
									)}
								</div>
								<div className='flex flex-col gap-5'>
									<div className='flex flex-col '>
										<p className='text-left font-bold text-primaryViolet text-base'>Subtitle </p>
										<MDEditor.Markdown className=' bg-containerGray ' style={{ color: '#5E639B', backgroundColor: 'white' }} source={course?.subtitle} />
									</div>
									<div className='flex flex-col '>
										<p className='text-left font-bold text-primaryViolet text-base'>Challenge Title </p>
										<MDEditor.Markdown className=' bg-containerGray ' style={{ color: '#5E639B', backgroundColor: 'white' }} source={course?.challangeTitle} />
									</div>
								</div>
							</div>
						</div>
						<Configuration
							course={course}
							changeVisibilty={changeVisibilty}
							setCreateJournalModal={setCreateJournalModal}
							setDeleteJournalModal={setDeleteJournalModal}
							setManageLangModalOpen={setManageLangModalOpen}
						/>
					</div>
					<div>
						{loading ? (
							<div className='w-full flex flex-row items-center justify-center min-h-[300px]'>
								<Loading size={70} primaryColor='#5E639B' stroke={3} />
							</div>
						) : (
							<div>
								<div className='flex flex-col flex-1'>
									<div className='program_days' style={{ display: 'block', padding: 0 }}>
										<p className='text-left text-primaryViolet font-bold text-lg mb-1'>List of days</p>
										<DragDropContext onDragEnd={handleDropQuestion}>
											<Droppable droppableId='droppable' direction='horizontal'>
												{(provided, snapshot) => (
													<div className='flex flex-row items-start gap-[30px]'>
														<div className='flex overflow-y-hidden overflow-x-auto w-full  pt-2 pb-5 items-center horizontal-grey-small-scroll' ref={provided.innerRef} {...provided.droppableProps}>
															{days?.map((item: any, index: number) => (
																<Draggable key={index.toString()} draggableId={index.toString()} index={index}>
																	{(provided: any, snapshot) => (
																		<CourseSingleDay
																			provided={provided}
																			days={days}
																			index={index}
																			currentDay={currentDay}
																			setCurrentDay={setCurrentDay}
																			setDeleteDay={setDeleteDay}
																			setIndexDayForDelete={setIndexDayForDelete}
																		/>
																	)}
																</Draggable>
															))}
															{provided.placeholder}
														</div>
														<div
															className={`max-w-[120px] mt-2 rounded-[10px] pointer text-sm p-[10px] font-semibold  flex items-center justify-center whitespace-nowrap bg-brandYellow hover:bg-primaryViolet text-primaryViolet hover:text-brandYellow transition not-selectable`}
															onClick={() => addNewDay()}
														>
															Add new day
														</div>
													</div>
												)}
											</Droppable>
										</DragDropContext>
									</div>
								</div>
								{!!course && days?.length !== 0 && currentDay !== -1 && <CourseDayEditing currentDay={currentDay} days={days} setDays={setDays} course={course} />}
							</div>
						)}
					</div>
				</div>
			</div>
			<ManageLanguageModal modalIsOpen={manageLangModalOpen} closeModal={closeManageLanguageModal} />
			<CreateEditCourseModal modalIsOpen={createJournalModal} closeModal={closeCreateJournalModal} course={course} reloadCourse={reloadCourse} />
			<ConfirmationModal modalIsOpen={deleteDay} closeModal={closeDeleteDay} confirmation={removeDay} message={'Do you want to delete this day?'} subMessage='The day will be permanently deleted.' />
			<ConfirmationModal
				modalIsOpen={deleteJournalModal}
				closeModal={closeDeleteJournalModal}
				confirmation={deleteJournal}
				message={'Do you want to delete this course?'}
				subMessage='The course will be permanently deleted.'
			/>
		</div>
	);
}

export default SingleCourseScreen;

const Configuration = ({
	course,
	setCreateJournalModal,
	changeVisibilty,
	setDeleteJournalModal,
	setManageLangModalOpen,
}: {
	course: any;
	setCreateJournalModal: any;
	changeVisibilty: any;
	setDeleteJournalModal: any;
	setManageLangModalOpen: any;
}) => {
	return (
		<div className='w-[330px] p-[20px]  border rounded-[10px] border-[#BEBECE] flex flex-col ml-[0px]'>
			<div className='flex flex-row items-center gap-2'>
				<Settings fill={'#FFBA00'} />
				<p className='text-primaryViolet font-bold text-[20px]'> Configuration</p>
			</div>
			<div className='flex flex-col flex-1 gap-[7px] mt-2'>
				<div className={`flex flex-row items-center cursor-pointer my-2`} onClick={() => {}}>
					<div className='border-[1.5px] border-primaryViolet rounded-full h-[18px] w-[18px] flex items-center justify-center' onClick={() => changeVisibilty()}>
						{course?.visible && <div className='rounded-full h-[10px] w-[10px] bg-primaryViolet'></div>}
					</div>
					<label className='text-primaryViolet text-[16px] font-medium ml-[13px] cursor-pointer not-selectable'>Course visible</label>
				</div>
				<div className='flex flex-row items-center '>
					<p className='text-left font-bold text-primaryViolet text-base'>Locale:&nbsp; </p>
					<p className='text-left font-bold text-primaryViolet text-base ellipsis'>{course?.locale?.name}</p>
				</div>
				<div className='flex flex-row items-center '>
					<p className='text-left font-bold text-primaryViolet text-base text-nowrap'>Category:&nbsp; </p>
					<p className='text-left font-bold text-primaryViolet text-base ellipsis'>{course?.mainCategory?.name}</p>
				</div>

				<button
					className='bg-[#ECEBF8] p-[10px] rounded-[10px] cursor-pointer text-primaryViolet font-bold text-[14px] hover:text-brandYellow hover:bg-primaryViolet ease-in-out duration-200 transition-all'
					onClick={() => setCreateJournalModal(true)}
				>
					Edit
				</button>
				<button
					className='bg-[#ECEBF8] p-[10px] rounded-[10px] cursor-pointer text-primaryViolet font-bold text-[14px] hover:text-brandYellow hover:bg-primaryViolet ease-in-out duration-200 transition-all'
					onClick={() => setManageLangModalOpen(true)}
				>
					Manage language
				</button>
				<div
					className='bg-white border border-redError p-[10px] rounded-[10px] cursor-pointer text-redError font-bold text-[14px] text-center hover:text-white hover:bg-redError ease-in-out duration-200 transition-all'
					onClick={() => setDeleteJournalModal(true)}
				>
					Delete course
				</div>
			</div>
		</div>
	);
};
